import supplierMappingService from "../../services/supplierMapping";
const getDefaultState = () => {
    return {
        SupplierMapping: {
            Id: 0,
            Entity: null,
            IgnitiaNGCode: null,
            SpectraCode: null,
            PayeeCode: null,
        },
    };
};

// initial state
const state = getDefaultState();

// getters
const getters = {
    SupplierMapping: (state) => {
        return state.SupplierMapping;
    }
};

// actions
const actions = {
    AddSupplierMapping(st, data) {
        return supplierMappingService.AddSupplierMapping(data, st.rootState.auth.idToken);
    },
    UpdateSupplierMapping(st, { id, data }) {
        return supplierMappingService.UpdateSupplierMapping(
            id,
            data,
            st.rootState.auth.idToken
        );
    },
    GetRequests(st, data) {
        return supplierMappingService.GetRequests(st.rootState.auth.idToken, data);
    },
    DeleteSupplierMapping(st, id) {
        return supplierMappingService.DeleteSupplierMapping(st.rootState.auth.idToken, id);
    },
    DownloadExcelUploadTemplate(st) {
        return supplierMappingService.DownloadExcelUploadTemplate(
            st.rootState.auth.idToken
        );
    },
    BulkUpload(st, data) {
        return supplierMappingService.BulkUpload(data, st.rootState.auth.idToken);
    },
};
// mutations
const mutations = {
    reset(st) {
        const s = getDefaultState();
        Object.keys(st).forEach((d) => {
            st[d] = s[d];
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};